import Styles from "../Form.module.css";
import CustomField from "../../shared/CustomTextField";
import { Formik } from "formik";
import { Button, MenuItem } from "@mui/material";
import {
  postDrivingTime,
  updateDrivingTime,
} from "../../../utils/API/userMethods";
import { useStore } from "../../../hooks/store";
import CarImageUploader from "./CarImageUploader";
import { postAuto, updateAuto } from "../../../utils/API/autoMethods";

export default function NewAutoForm() {
  const store = useStore();
  const {
    id,
    brend,
    model,
    year,
    license_plate,
    is_auto_transmission,
    category_id,
    status,
    photo, // Массив объектов [{id, url, is_primary}, ...] с бэкенда
    categoryList,
  } = store.form.dataToUpdate;

  const initialPhotos = photo || [];

  // Метод сборки MultipartFormData под требования бэкенда
  const prepareFormData = (values) => {
    const formData = new FormData();

    // 1. Формируем чистый JSON объект с данными автомобиля
    const carData = {
      brend: values.brend,
      model: values.model,
      year: Number(values.year),
      license_plate: values.license_plate,
      // Переводим булево значение или число обратно в формат 1 / 0
      is_auto_transmission: values.is_auto_transmission ? 1 : 0,
      category_id: String(values.category_id),
      status: values.status,
      primaryPhotoName: values.primaryPhotoName, // Из аплоадера
    };

    // Если это редактирование, добавляем id машины в json объект data
    if (values.id) {
      carData.id = String(values.id);
    }

    // Записываем JSON-строку в поле 'data'
    formData.append("data", JSON.stringify(carData));

    // 2. Закидываем новые файлы в массив 'photoToAdd'
    if (values.photoToAdd && values.photoToAdd.length > 0) {
      values.photoToAdd.forEach((file) => {
        formData.append("photoToAdd", file);
      });
    }

    // 3. Закидываем ID удаляемых фото в 'photoToDelete' (передаем массивом)
    if (values.photoToDelete && values.photoToDelete.length > 0) {
      formData.append(
        "photoToDelete",
        JSON.stringify([...values.photoToDelete]),
      );
      //   values.photoToDelete.forEach((id) => {
      // formData.append("photoToDelete", id);
      //   });
    }

    return formData;
  };

  const handleSubmit = (values, callBack) => {
    const dataToSend = prepareFormData(values);

    postAuto(dataToSend).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert("Авто успешно добавлено", "success");
        store.form.callBack();
        return;
      }
      callBack();
      store.setAlert(data, "error");
    });
  };

  const handleUpdate = (values, callBack) => {
    const dataToSend = prepareFormData(values);

    updateAuto(values.id, dataToSend).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert("Авто успешно изменено", "success");
        store.form.callBack();
        return;
      }
      callBack();
      store.setAlert(data, "error");
    });
  };

  return (
    <Formik
      initialValues={{
        id: id || null,
        brend: brend || "",
        model: model || "",
        year: year || "",
        license_plate: license_plate || "",
        // Преобразуем 1/0 от сервера в булево значение для удобства чекбокса/селекта
        is_auto_transmission: is_auto_transmission === 1,
        category_id: category_id || "",
        status: status || "active",

        // Поля управления фотографиями
        photoToAdd: [],
        photoToDelete: [],
        primaryPhotoName:
          initialPhotos.find((p) => p.is_primary === 1)?.url || null,
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        values.id
          ? handleUpdate(values, () => setSubmitting(false))
          : handleSubmit(values, () => setSubmitting(false));
      }}>
      {({
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => (
        <>
          <p>
            {values.id ? "Редактирование автомобиля" : "Добавление автомобиля"}
          </p>
          <form onSubmit={handleSubmit}>
            <div
              className={Styles.form_content}
              style={{ flexDirection: "row" }}>
              <div className={Styles.form_fields}>
                <CustomField
                  disabled={isSubmitting}
                  name="brend"
                  placeholder="Toyota"
                  label={"Бренд"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.brend}
                />
                <CustomField
                  disabled={isSubmitting}
                  name="model"
                  placeholder="Prius V"
                  label={"Модель"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.model}
                />
                <CustomField
                  disabled={isSubmitting}
                  name="license_plate"
                  label={"Гос.номер"}
                  placeholder="T123TT"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.license_plate}
                />
                <CustomField
                  disabled={isSubmitting}
                  name="year"
                  label={"Год выпуска"}
                  placeholder="2012"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="number"
                  value={values.year}
                />
                <CustomField
                  disabled={isSubmitting}
                  select
                  name="category_id"
                  label={"Категория"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.category_id}>
                  {categoryList?.map((category) => (
                    <MenuItem key={category.id} value={Number(category.id)}>
                      {category.name}
                    </MenuItem>
                  ))}
                </CustomField>
                <CustomField
                  disabled={isSubmitting}
                  select
                  name="is_auto_transmission"
                  label={"Коробка передач"}
                  onChange={(e) =>
                    setFieldValue(
                      "is_auto_transmission",
                      e.target.value === "true",
                    )
                  }
                  onBlur={handleBlur}
                  value={String(values.is_auto_transmission)}>
                  <MenuItem value="false">Механика</MenuItem>
                  <MenuItem value="true">Автомат</MenuItem>
                </CustomField>
              </div>

              <div className={Styles.form_fields}>
                <CarImageUploader
                  initialImages={initialPhotos}
                  onImagesChange={({
                    newFiles,
                    primaryPhotoName,
                    photoToDelete,
                  }) => {
                    setFieldValue("photoToAdd", newFiles);
                    setFieldValue("primaryPhotoName", primaryPhotoName);
                    setFieldValue("photoToDelete", photoToDelete);
                  }}
                />
              </div>
            </div>

            <div
              className="form_actions"
              style={{ paddingLeft: "20px", paddingRight: "20px" }}>
              <Button variant="contained" type="submit" disabled={isSubmitting}>
                Сохранить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
